import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <div className="w-full h-full bg-gradient-to-r from-black via-black/70 to-transparent absolute z-10" />
        <img
          src="https://res.cloudinary.com/dhdyo9wwq/image/upload/v1750081224/freepik__background__97442_fwzjhb.png"
          alt="Modern enterprise workspace"
          className="w-full h-full object-cover grayscale"
        />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center min-h-screen py-12">
        <div className="space-y-8">
          <div>
            <p className="text-[10px] sm:text-xs md:text-[11px] tracking-[0.3em] uppercase text-gray-400 mb-4 sm:mb-6">
              For Organizations • Teams • Enterprises
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-thin tracking-tight leading-tight mb-6">
              Custom AI <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
                Solutions
              </span>
            </h1>
            <div className="w-20 sm:w-24 h-px bg-white mb-6 sm:mb-8" />
            <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed tracking-wide text-gray-300 max-w-2xl">
              Empower your organization with tailored AI strategies, training and technology designed to drive
              innovation, efficiency and growth.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/consultation">
              <button className="group border border-white px-10 sm:px-12 py-3.5 sm:py-4 text-[11px] sm:text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300">
                <span className="group-hover:tracking-[0.3em] transition-all duration-300 flex items-center">
                  Schedule a Consultation
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
